import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useSendEmail = () => {
  return useMutation<any, Error, any>({
    mutationFn: async (payload) => {
      const response = await client(`api/sendEmail`, {
        method: "POST",
        data: payload,
      });

      if (response.error) {
        throw new Error(response.error);
      }
      return response;
    },
  });
};

export const useSignup = () => {
  return useMutation<any, Error, any>({
    mutationFn: async (payload) => {
      const response = await client(`api/signup`, {
        method: "POST",
        data: payload,
      });
      localStorage.setItem("userId", response?.user?.id);
      if (response.error) {
        throw new Error(response.error);
      }
      return response;
    },
  });
};

export const useLogin = () => {
  const queryClient = useQueryClient();
  return useMutation<any, Error, any>({
    mutationFn: async (payload) => {
      const response = await client(`api/login`, {
        method: "POST",
        data: payload,
      });

      if (response.error) {
        throw new Error(response.error);
      }
      localStorage.setItem("token", response.token);
      queryClient.invalidateQueries({
        queryKey: ["token"],
      });
      queryClient.invalidateQueries({
        queryKey: ["getLoggedInUser"],
      });
      return response;
    },
  });
};

export const useGetLoggedInUser = () =>
  useQuery({
    queryKey: ["getLoggedInUser"],
    queryFn: async () => {
      const response = await client(`api/getLoggedInUser`);
      return response;
    },
  });

export const useCreateExhibitor = () => {
  return useMutation<any, Error, any>({
    mutationFn: async (payload) => {
      const response = await client(`api/create-exhibitor`, {
        method: "POST",
        data: payload,
      });

      if (response.error) {
        throw new Error(response.error);
      }
      return response;
    },
  });
};

export const useUploadMedia = () => {
  return useMutation<any, Error, any>({
    mutationFn: async (payload) => {
      const response = await client(`media-upload/mediaFiles/ad-images`, {
        method: "POST",
        data: payload,
      });
      if (response?.error) {
        throw new Error(response.error);
      }
      return response;
    },
  });
};

export const useCreatePaymentIntent = () => {
  return useMutation<any, Error, any>({
    mutationFn: async (payload) => {
      const response = await client(`api/createPaymentIntent`, {
        method: "POST",
        data: payload,
      });
      if (response?.error) {
        throw new Error(response.error);
      }
      return response;
    },
  });
};
